/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect, useState } from "react";
import { useAppSelector } from "../../app/hooks";
import { useFetchUnreadNotification } from "../../pages/chat/hooks/useFetchUnreadNotification";

interface IProps {
  url: string
}
const NotificationBubble: FC<IProps> = ({ url }) => {
  const { user } = useAppSelector((state) => state.auth);
  const { notifications } = useAppSelector((state) => state.chat);
  const [unreadMessageCount, setUnreadMessageCount] = useState(0);
  useFetchUnreadNotification(String(user?.username), 10, String(user?.tenantId));
  const loadUnreadMessageCount = () => {
    let result = 0;
    if (url == "/messages") {
      result = (notifications.filter(a => (a.campaignId ?? 0) == 0)?.length ?? 0)
    } else if (url == "/leads") {
      result = (notifications.filter(a => (a.campaignId ?? 0) > 0)?.length ?? 0)
    }
    setUnreadMessageCount(result);
  }
  useEffect(() => {
    loadUnreadMessageCount();
  }, [notifications]);
  return (
    unreadMessageCount > 0 ?
      <span className="w-[7px] h-[7px] bg-success rounded-full absolute -top-0.5 right-0" />
      : <></>
  )

}
export default NotificationBubble;